export default {
  //去重
  unique5:function(arr) {
    var x = new Set(arr);
    return [...x];
  },
  //字母排序
  letterSort:function(arr){
    arr.sort(function(a,b){
      if(a.toString().toLowerCase()>b.toString().toLowerCase())
        return 1;
      return -1;
    })
    return arr
  },
  //设置cookie
  setCookie:function(c_name,value,expiredays){
    var exdate=new Date();
        expiredays = 1;
    exdate.setDate(exdate.getDate()+expiredays)
    document.cookie=c_name+ "=" +escape(value)+
      ((expiredays==null) ? "" : ";expires="+exdate.toGMTString()+";path=/")
  },
  //取回cookie
  getCookie:function(c_name){
    if (document.cookie.length>0) {
      var c_start=document.cookie.indexOf(c_name + "=")
      if (c_start!=-1) {
         c_start=c_start + c_name.length+1
        var c_end=document.cookie.indexOf(";",c_start)
        if (c_end==-1){
          c_end=document.cookie.length
        }
        return unescape(document.cookie.substring(c_start,c_end))
      }
    }
    return ""
  }
}



// WEBPACK FOOTER //
// ./src/common/js/commonJS.js